<script setup lang="ts">
import { UITag } from '@groover-dev/groover-ui'

type Props = {
  color?: 'primary' | 'accent'
  darkenBg?: boolean
  hideHypeText?: boolean
}

const { t } = useI18n()

const props = withDefaults(defineProps<Props>(), {
  color: 'primary',
  darkenBg: false,
  hideHypeText: false,
})

const ariaLabel = computed(() => {
  return props.color === 'accent'
    ? t('hype.featureName') + ' (via Groover Plus)'
    : t('hype.featureName')
})
</script>

<template>
  <UITag
    :color="color"
    icon-left-name="material-symbols:bolt-rounded"
    :text="hideHypeText ? undefined : t('hype.featureName')"
    :class="{
      '!tw-bg-fill-primary-discrete': darkenBg,
    }"
    :aria-label="hideHypeText ? ariaLabel : undefined"
  />
</template>
